'use client' // Error boundaries must be Client Components

import { useEffect } from 'react'
import ErrorGrid from './error-grid'
import HeaderInit from './header-init'
import { getPlacementDebugInfoFromErrorMessage, PLACEMENT_ERROR_PREFIX } from './error-constants'
import { reportTrackJSError } from './trackjs'

export default function Error({ error }: { error: Error & { digest?: string }; reset: () => void }) {
    useEffect(() => {
        reportTrackJSError(error)
    }, [error])

    const isPlacementError = error.message?.startsWith(PLACEMENT_ERROR_PREFIX)
    const placementDebugInfo = getPlacementDebugInfoFromErrorMessage(error.message)

    useEffect(() => {
        if (placementDebugInfo) {
            console.info('[placements debug]', placementDebugInfo)
        }
    }, [placementDebugInfo])

    const heading = 'Oh-oh! Something went wrong!'
    const body = isPlacementError ? 'Please try again later.' : 'Find another GIF from our trending feed'

    return (
        <HeaderInit routeName="/error">
            <div className="mt-3 flex flex-col gap-3">
                <div className="flex flex-col items-center justify-center rounded-lg bg-gradient-primary p-5">
                    <h2>{heading}</h2>
                    <p>{body}</p>
                </div>
                {isPlacementError ? (
                    <img
                        src={`${'https://giphy.com'}/static/img/error_pages/crying-cowbow-emoji.gif`}
                        alt="Error"
                        className="mx-auto mt-4 h-[220px] w-[220px]"
                    />
                ) : (
                    <ErrorGrid />
                )}
            </div>
        </HeaderInit>
    )
}
